import { render } from "./PrivacyPolicy.vue?vue&type=template&id=19e7f307&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=19e7f307&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e7f307"]])

export default __exports__